// extracted by mini-css-extract-plugin
export default {"enablePromptDescription":"AnalyticsPdf_enablePromptDescription__OQ9VP","pdfAnalyticsWrapper":"AnalyticsPdf_pdfAnalyticsWrapper__xCXzg"};